import * as locales from '@mui/material/locale';

import { ContactProps } from './Contact';
import { PartnerGroupProps } from './PartnerGroup';
import { ReviewerAssignmentProps } from './ReviewerAssignment';

export type Locales = keyof typeof locales;

export interface UserProps {
  admin: boolean;
  b2CId: string;
  contactId?: number | null;
  partnerGroupId?: number | null;
  disabled: boolean;
  email: string;
  userType: UserType;
  validated: boolean;
  preferredLanguage?: Locales | null;
  userCanImpersonate?: boolean;
  userImpersonatedBy?: string | null;
  userEmail?: string | null;
  userContactId?: number | null;
  userAccountType?: UserType | null;
  userImpersonated?: string | null;
  contact?: ContactProps | null;
  partnerGroup?: PartnerGroupProps | null;
  signupMethod?: SignupMethod;
  currentPartnerId?: number | null;
  reviewerAssignments?: ReviewerAssignmentProps[];
}

export enum SignupMethod {
  Unknown = 1,
  Email = 2,
  Google = 3,
  Facebook = 4,
  Microsoft = 5,
  Apple = 6,
  LinkedIn = 7,
  ExternalAzureAd = 8,
}

export function signupMethodAsString(signupMethod?: SignupMethod): string {
  switch (signupMethod) {
    case SignupMethod.Email:
      return 'Email';
    case SignupMethod.Google:
      return 'Google';
    case SignupMethod.Facebook:
      return 'Facebook';
    case SignupMethod.Microsoft:
      return 'Microsoft';
    case SignupMethod.Apple:
      return 'Apple';
    case SignupMethod.LinkedIn:
      return 'LinkedIn';
    case SignupMethod.ExternalAzureAd:
      return 'External Azure AD';
    case SignupMethod.Unknown:
    default:
      return 'Unknown';
  }
}

export enum UserType {
  Applicant = 1,
  Adf = 2,
  StateCoordinator = 3,
  RegionalCoordinator = 4,
  NationalProgrammeLead = 5,
}

export function userTypeAsString(userType: UserType): string {
  switch (userType) {
    case UserType.Applicant:
      return 'Applicant';
    case UserType.Adf:
      return 'ADF';
    case UserType.StateCoordinator:
      return 'State Coordinator';
    case UserType.RegionalCoordinator:
      return 'Regional Coordinator';
    case UserType.NationalProgrammeLead:
      return 'National Programme Lead';
    default:
      return 'Applicant';
  }
}

export function userTypeStringToEnum(userType: string): UserType {
  switch (userType) {
    case 'Applicant':
      return UserType.Applicant;
    case 'ADF':
      return UserType.Adf;
    case 'State Coordinator':
      return UserType.StateCoordinator;
    case 'Regional Coordinator':
      return UserType.RegionalCoordinator;
    case 'National Programme Lead':
    case 'International Partner': // TODO: Remove 'International Partner' case when that user type is fully deprecated
      return UserType.NationalProgrammeLead;
    default:
      return UserType.Applicant;
  }
}
